
import notify from 'bootstrap-notify/bootstrap-notify.min.js';
import restMessages         from 'RestMessages';

//====================================================================================================================
// An exported singleton for serving up bootstrap-notify messages.
//
// Documentation: http://bootstrap-notify.remabledesigns.com
//
// - Brad Trebilcock, March 15 2016
//====================================================================================================================
class NotificationService {

    success(message, options, settings) {

        const _options = this.getDefaultSuccessOptions();
        const _settings = this.getDefaultSuccessSettings();

        _options.message = message;

        this.showNotification(_options,_settings, options, settings);
    }

    info(message, options, settings) {

        const _options = this.getDefaultInfoOptions();
        const _settings = this.getDefaultInfoSettings();

        _options.message = message;

        this.showNotification(_options,_settings, options, settings);
    }

    warning(message, options, settings) {

        const _options = this.getDefaultWarningOptions();
        const _settings = this.getDefaultWarningSettings();

        _options.message = message;

        this.showNotification(_options,_settings, options, settings);
    }

    error(message, options, settings) {

        const _options = this.getDefaultErrorOptions();
        const _settings = this.getDefaultErrorSettings();
        
        let msg = message;
        
        if(message && message.CODE){
            msg = restMessages.codeToMessage(message.CODE);
        }

        _options.message = msg;

        this.showNotification(_options,_settings, options, settings);
    }

    showNotification(_options,_settings, options, settings) {

        // override defaults
        for (const key in options) {
            if (options.hasOwnProperty(key)) {
                _options[key] = options[key];
            }
        }

        for (const key in settings) {
            if (settings.hasOwnProperty(key)) {
                _settings[key] = settings[key];
            }
        }

        $.notify(_options,_settings);
    }

    getDefaultSuccessOptions() {
        return {};
    }

    getDefaultSuccessSettings() {
        return {
            element: 'body',
            type: 'success',
            allow_dismiss: false,
            delay: 3000,
            placement: {
                from: 'top',
                align: 'center'
            },
            offset: {
                y: 10
            },
            z_index: 999999,
            animate: {
                enter: 'animated fadeInDown',
                exit: 'animated fadeOutUp'
            },
            template:
            `<div class="alert alert-{0} alert-dismissible fade in" role="alert">
                <div data-notify="icon" class="alert-icon">
                    <i class="fa pf-success"></i>
                </div>
                <div class="alert-content">
                    <strong>Success! </strong> {2}
                </div>
                <div class="alert-close">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
            </div>`
        };
    }

    getDefaultInfoOptions() {
        return {};
    }

    getDefaultInfoSettings() {
        return {
            element: 'body',
            type: 'info',
            allow_dismiss: false,
            delay: 3000,
            placement: {
                from: 'top',
                align: 'center'
            },
            offset: {
                y: 10
            },
            animate: {
                enter: 'animated fadeInDown',
                exit: 'animated fadeOutUp'
            },
            z_index: 999999,
            template:
             `<div class="alert alert-{0} alert-dismissible fade in" role="alert">
                <div data-notify="icon" class="alert-icon">
                    <i class="fa pf-info"></i>
                </div>
                <div class="alert-content">
                    <strong>Info! </strong> {2}
                </div>
                <div class="alert-close">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
             </div>`
        };
    }

    getDefaultWarningOptions() {
        return {};
    }

    getDefaultWarningSettings() {
        return {
            element: 'body',
            type: 'warning',
            allow_dismiss: false,
            delay: 3000,
            placement: {
                from: 'top',
                align: 'center'
            },
            offset: {
                y: 10
            },
            animate: {
                enter: 'animated fadeInDown',
                exit: 'animated fadeOutUp'
            },
            z_index: 999999,
            template:
            `<div class="alert alert-{0} alert-dismissible fade in" role="alert">
                <div data-notify="icon" class="alert-icon">
                    <i class="fa pf-warning"></i>
                </div>
                <div class="alert-content">
                    <strong>Warning! </strong> {2}
                </div>
                <div class="alert-close">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
            </div>`
        };
    }

    getDefaultErrorOptions() {
        return {};
    }

    getDefaultErrorSettings() {
        return {
            element: 'body',
            type: 'danger',
            allow_dismiss: true,
            delay: 10000,
            placement: {
                from: 'top',
                align: 'center'
            },
            offset: {
                y: 10
            },
            z_index: 999999,
            animate: {
                enter: 'animated fadeInDown',
                exit: 'animated fadeOutUp'
            },
            template:
                `<div class="alert alert-{0} alert-dismissible fade in" role="alert">
                    <div data-notify="icon" class="alert-icon">
                        <i class="fa pf-error"></i>
                    </div>
                    <div class="alert-content">
                        <strong>Error! </strong> {2}
                    </div>
                    <div class="alert-close">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button> 
                    </div> 
                </div>`
        };
    }

} // class

const notificationService = new NotificationService();
export default notificationService;
